export enum AppConfigKey {
  AmlConfig = 'aml_config',
  BanksMap = 'banks_map',
  PaymentTypeMap = 'payment_types_map',
  SupportedBanks = 'supported_banks',
  SupportedPaymentTypes = 'supported_payment_types',
  SupportedCurrencies = 'supported_currencies',
  ReverseBanksMap = 'reverse_banks_map',
  TradeMethods = 'trade_methods',
  PaymentLinkDomains = 'payment_link_domains',
  PaymentLinkDomainToBankMap = 'payment_link_domain_to_bank_map',
  BankToPaymentTypeMap = 'bank_to_payment_type_map',
  PaymentMethodsByType = 'payment_methods_by_type',
  MonitoringRanges = 'monitoring_ranges',
  Receipts = 'receipts',
  RequisitesVerification = 'requisites_verification',
  ExceptionWords = 'exception_words',
  CurrenciesIdMap = 'currencies_id_map',
  BanksIdMap = 'banks_id_map',
  AvailableP2PProviderTypes = 'available_p2p_provider_types',
  PayinRequisitesGroups = 'payin_requisites_groups',
  ThemeOverrides = 'theme_overrides',
  SidebarHeader = 'sidebar_header',
  OrderStatusReasons = 'payin_order_status_reason',
  EndpointIdMap = 'endpoint_id_map',
  OtherBankCodeByCurrency = 'other_bank_code_currency_map',
  InternalPaymentTypes = 'internal_payment_types',
  TelegramOrdersBotUsersWhitelist = 'telegram_ordes_bot_users_whitelist',
  TelegramOrdersBotConfig = 'telegram_orders_bot_config',
  AdditionalP2POrderFields = 'additional_p2p_order_fields',
  AccountNumberQrSupportedCombinations = 'account_number_qr_supported_combinations',
  MultitransferMap = 'multitransfer_map',
  MultitransferConfig = 'multitransfer_config',
  ResolveCaptchaConfigs = 'resolve_captcha_configs',
  PaymentMethodNamesMap = 'payment_method_names_map',
  InternalTransferCategories = 'internal_transfer_categories',
}
